export default __webpack_public_path__ + "static/media/mdfl-nameplate.9410f5d3.svg";